(() => {
  const STORAGE_KEY = 'pulse-bags:wishlist:v1';
  const root = document.documentElement;

  function readItems() {
    try {
      const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.filter(item => item && item.id && item.title && item.url) : [];
    } catch (error) {
      return [];
    }
  }

  function writeItems(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      announce('Wishlist storage is unavailable in this browser.');
    }
  }

  function safeProductUrl(value) {
    try {
      const url = new URL(value || '/collections/all', window.location.origin);
      if (url.origin !== window.location.origin || !url.pathname.startsWith('/products/')) return '/collections/all';
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return '/collections/all';
    }
  }

  function safeImageUrl(value) {
    try {
      if (!value) return '';
      const url = new URL(value, window.location.origin);
      if (!['https:', 'http:'].includes(url.protocol)) return '';
      return url.href;
    } catch (error) {
      return '';
    }
  }

  function announce(message) {
    document.querySelectorAll('[data-pulse-wishlist-status]').forEach(node => { node.textContent = message; });
  }

  function getItemFromButton(button) {
    return {
      id: String(button.dataset.productId || ''),
      title: String(button.dataset.productTitle || 'Saved product'),
      url: safeProductUrl(button.dataset.productUrl),
      image: safeImageUrl(button.dataset.productImage),
      imageAlt: String(button.dataset.productImageAlt || button.dataset.productTitle || ''),
      price: String(button.dataset.productPrice || ''),
      variantId: String(button.dataset.productVariantId || '')
    };
  }

  function updateButtons() {
    const items = readItems();
    const savedIds = new Set(items.map(item => String(item.id)));
    document.querySelectorAll('[data-pulse-wishlist-toggle]').forEach(button => {
      const saved = savedIds.has(String(button.dataset.productId || ''));
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      const title = button.dataset.productTitle || 'Product';
      button.setAttribute('aria-label', (saved ? 'Remove ' : 'Add ') + title + (saved ? ' from wishlist' : ' to wishlist'));
      button.title = saved ? 'Remove from wishlist' : 'Add to wishlist';
    });
  }

  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  function renderWishlistPage() {
    const page = document.querySelector('[data-pulse-wishlist-page]');
    if (!page) return;

    const grid = page.querySelector('[data-pulse-wishlist-grid]');
    const empty = page.querySelector('[data-pulse-wishlist-empty]');
    const count = page.querySelector('[data-pulse-wishlist-count]');
    if (!grid || !empty || !count) return;

    const items = readItems();
    count.textContent = items.length + (items.length === 1 ? ' item saved' : ' items saved');
    grid.replaceChildren();

    if (!items.length) {
      grid.hidden = true;
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    grid.hidden = false;

    items.forEach(item => {
      const card = el('article', 'pulse-wishlist-item');
      const productLink = el('a', 'pulse-wishlist-item__media');
      productLink.href = safeProductUrl(item.url);
      productLink.setAttribute('aria-label', 'View ' + item.title);

      const imageUrl = safeImageUrl(item.image);
      if (imageUrl) {
        const image = el('img');
        image.src = imageUrl;
        image.alt = String(item.imageAlt || item.title);
        image.loading = 'lazy';
        image.decoding = 'async';
        productLink.appendChild(image);
      } else {
        productLink.appendChild(el('span', '', 'PULSE'));
      }

      const title = el('h2', 'pulse-wishlist-item__title');
      const titleLink = el('a', '', item.title);
      titleLink.href = safeProductUrl(item.url);
      title.appendChild(titleLink);
      card.appendChild(productLink);
      card.appendChild(title);
      if (item.price) card.appendChild(el('p', 'pulse-wishlist-item__price', item.price));

      const actions = el('div', 'pulse-wishlist-item__actions');
      const viewLink = el('a', 'pulse-wishlist-item__view', 'View product');
      viewLink.href = safeProductUrl(item.url);
      const removeButton = el('button', 'pulse-wishlist-item__remove', 'Remove');
      removeButton.type = 'button';
      removeButton.dataset.pulseWishlistRemove = String(item.id);
      removeButton.setAttribute('aria-label', 'Remove ' + item.title + ' from wishlist');
      actions.append(viewLink, removeButton);
      card.appendChild(actions);
      grid.appendChild(card);
    });
  }

  function refresh() {
    updateButtons();
    renderWishlistPage();
  }

  document.addEventListener('click', event => {
    const removeButton = event.target.closest('[data-pulse-wishlist-remove]');
    if (removeButton) {
      const id = String(removeButton.dataset.pulseWishlistRemove || '');
      const items = readItems().filter(item => String(item.id) !== id);
      writeItems(items);
      refresh();
      announce('Item removed from your wishlist.');
      return;
    }

    const button = event.target.closest('[data-pulse-wishlist-toggle]');
    if (button) {
      event.preventDefault();
      const item = getItemFromButton(button);
      if (!item.id) return;
      const items = readItems();
      const alreadySaved = items.some(saved => String(saved.id) === item.id);
      const nextItems = alreadySaved
        ? items.filter(saved => String(saved.id) !== item.id)
        : [item, ...items];
      writeItems(nextItems);
      refresh();
      announce(alreadySaved ? 'Removed from your wishlist.' : 'Added to your wishlist.');
    }
  });

  document.addEventListener('click', event => {
    const swatch = event.target.closest('[data-variant-image][data-variant-url]');
    if (!swatch) return;
    const card = swatch.closest('.pulse-best-sellers__card, .pulse-collection-card');
    const toggle = card?.querySelector('[data-pulse-wishlist-toggle]');
    if (!toggle) return;

    toggle.dataset.productImage = swatch.dataset.variantImage || toggle.dataset.productImage || '';
    toggle.dataset.productImageAlt = swatch.dataset.variantAlt || toggle.dataset.productImageAlt || '';
    toggle.dataset.productUrl = swatch.dataset.variantUrl || toggle.dataset.productUrl || '';
    toggle.dataset.productPrice = swatch.dataset.variantPrice || toggle.dataset.productPrice || '';
    const variantMatch = (swatch.dataset.variantUrl || '').match(/[?&]variant=(\d+)/);
    if (variantMatch) toggle.dataset.productVariantId = variantMatch[1];
  });

  window.addEventListener('storage', event => {
    if (event.key === STORAGE_KEY) refresh();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();